import { render } from "./Vendors.vue?vue&type=template&id=bbb90ba2&ts=true"
import script from "./Vendors.vue?vue&type=script&lang=ts"
export * from "./Vendors.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__